import { useMemo } from 'react';

import { useParseEmailTemplate as useParseEmailTemplateCore } from '@/modules/core/hooks';

import { useGetEmailTemplateSkeletonQuery, useGetEmailTemplateVariablesQuery } from '../queries';

export const useParseEmailTemplate = (templateId?: string, orgId?: string) => {
  const { data: htmlTemplate, isLoading: isHtmlTemplateLoading } =
    useGetEmailTemplateSkeletonQuery(templateId);
  const { data: htmlTemplateVariables, isLoading: isVariablesLoading } = useGetEmailTemplateVariablesQuery(
    templateId,
    orgId
  );

  const isLoading = useMemo(
    () => isHtmlTemplateLoading || isVariablesLoading,
    [isHtmlTemplateLoading, isVariablesLoading]
  );
  const handleGetHtml = useParseEmailTemplateCore();

  const preparedTemplate = useMemo(() => {
    if (isVariablesLoading || !htmlTemplate) {
      return null;
    }
    return handleGetHtml(htmlTemplate, htmlTemplateVariables);
  }, [handleGetHtml, htmlTemplate, htmlTemplateVariables, isVariablesLoading]);

  return {
    isLoading,
    preparedTemplate,
  };
};
